import { Badge, Breadcrumb, Button, Calendar, Checkbox, Col, DatePicker, Divider, Drawer, Dropdown, Flex, Form, Input, InputNumber, Layout, Radio, Row, Select, Space, Table, Tag, theme } from 'antd';
import {
    SendOutlined,
    MoreOutlined,
    MessageOutlined,
    UnlockOutlined,
    EyeOutlined,
    LockOutlined,
    EditOutlined
} from '@ant-design/icons';
import React, { useRef, useState } from 'react'
import TextArea from 'antd/es/input/TextArea';

const { Search } = Input;
const { Header, Sider, Content } = Layout;


const options = [
    {
        label: 'Never',
        value: 'Never',
    },
    {
        label: 'On',
        value: 'On',
    },
    {
        label: 'After',
        value: 'After',
    },
];
export default function RecurringEnd() {

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [value, setValue] = useState('Never');
    const [showTextArea, setShowTextArea] = useState(false);

    const onChange = ({ target: { value } }) => {
        console.log('radio checked', value);
        setValue(value);
    };

    const onChangeSignatory = (e) => {
        setShowTextArea(e.target.checked)
    };

    return (
        <>
            <Form>
                <Form.Item>
                    <Radio.Group options={options} onChange={onChange} value={value} optionType="button" />
                </Form.Item>
                <br />
                {value === 'On' && (
                    <Form.Item>
                        <DatePicker style={{ width: '100%' }}  />
                    </Form.Item>
                )}
                {value === 'After' && (
                    <Form.Item>
                        <InputNumber
                            min={0}
                            defaultValue={1}
                            addonAfter='Occurance'
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                )}
            </Form>

        </>
    )
}